import useSearchSubscriptionFeature from './hooks/useSearchSubscriptionFeature';

export default useSearchSubscriptionFeature;
